import { type JSX, Show } from 'solid-js';
import { t } from '../i18n';
import { canStopTask } from '../lib/fleet';
import type { StopTarget } from '../lib/taskStop';
import type { TaskDetail } from '../lib/tasks';
import { Button } from './ui/Button';

// The stop control on a run's view (#1906) — pure presenter; the route owns the
// mutation. Split out of <FleetAudit/> so that route stays a container over its
// stream, and because the absence rule is worth having in one readable place.
//
// ABSENT, never disabled, on all three of: the task not resolved yet (the run's
// first frame has not landed, so there is nothing to name), the point read still
// in flight or failed, and terminal work the server would refuse. A control that
// is visible and cannot act teaches the reader the button is broken.

export type RunStopActionProps = {
  readonly task: TaskDetail | null;
  readonly onStop: (target: StopTarget) => void;
};

export function RunStopAction(props: RunStopActionProps): JSX.Element {
  const stoppable = (): StopTarget | null => {
    const row = props.task;
    if (row === null || !canStopTask(row.status)) return null;
    return { id: row.id, title: row.title, repo_full_name: row.repo_full_name };
  };
  return (
    <Show when={stoppable()}>
      {(target) => (
        <Button
          variant="destructive"
          aria-label={t('fleet.stop.aria', { title: target().title })}
          onClick={() => props.onStop(target())}
        >
          {t('fleet.stop.action')}
        </Button>
      )}
    </Show>
  );
}
